export const FormattedData = (data, charLimit = 40) => {
  const trimmedData = data.slice(0, charLimit);

  return trimmedData + (data.length > charLimit ? '...' : '');
};

export const FormattedText = (data, charLimit = 18) => {
  const trimmedData = data.slice(0, charLimit);

  return trimmedData + (data.length > charLimit ? '...' : '');
};